/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DonationAnswersDto } from './DonationAnswersDto';
import {
    DonationAnswersDtoFromJSON,
    DonationAnswersDtoFromJSONTyped,
    DonationAnswersDtoToJSON,
    DonationAnswersDtoToJSONTyped,
} from './DonationAnswersDto';

/**
 * 
 * @export
 * @interface SaveDonationsRequest
 */
export interface SaveDonationsRequest {
    /**
     * 
     * @type {DonationAnswersDto}
     * @memberof SaveDonationsRequest
     */
    answers: DonationAnswersDto;
}

/**
 * Check if a given object implements the SaveDonationsRequest interface.
 */
export function instanceOfSaveDonationsRequest(value: object): value is SaveDonationsRequest {
    if (!('answers' in value) || value['answers'] === undefined) return false;
    return true;
}

export function SaveDonationsRequestFromJSON(json: any): SaveDonationsRequest {
    return SaveDonationsRequestFromJSONTyped(json, false);
}

export function SaveDonationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveDonationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': DonationAnswersDtoFromJSON(json['answers']),
    };
}

export function SaveDonationsRequestToJSON(json: any): SaveDonationsRequest {
    return SaveDonationsRequestToJSONTyped(json, false);
}

export function SaveDonationsRequestToJSONTyped(value?: SaveDonationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answers': DonationAnswersDtoToJSON(value['answers']),
    };
}

